import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/router.ts'
import './index.css'
import 'animate.css'
import 'vue3-tooltip/tooltip.css'
import { setDefaultApolloClient } from '@/graphql.ts'
import Toast from 'vue-toastification'
import * as Sentry from '@sentry/vue'
import 'vue-toastification/dist/index.css'
import { setupFontAwesome } from '@/plugins/fontawesome.ts'
import { TooltipDirective } from 'vue3-tooltip'
import { DEFAULT_ENVIRONMENT } from '@/config/env.const.ts'

setupFontAwesome()

const pinia = createPinia()

const app = createApp({
  render: () => h(App),
  setup () {
    setDefaultApolloClient(DEFAULT_ENVIRONMENT)
  },
})

if (import.meta.env.VITE_ENABLE_SENTRY) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.CROWDY_ENV,
    tracesSampleRate: 0.2,
  })
}

app.use(pinia)
app.use(router)
app.use(Toast, {
  // @ts-expect-error
  onMounted: (_, toastApp) => {
    toastApp.use(router) // Allow use RouterLink inside custom toasts
  },
})
app.directive('tooltip', TooltipDirective)
app.mount('#app')

